import { render, staticRenderFns } from "./OneDropdown.vue?vue&type=template&id=2779f2bc&scoped=true&lang=pug&"
import script from "./OneDropdown.vue?vue&type=script&lang=ts&"
export * from "./OneDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./OneDropdown.vue?vue&type=style&index=0&id=2779f2bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_vd7qwssw5i3h3fjzjs5bz4d2ha/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2779f2bc",
  null
  
)

export default component.exports